import React from 'react';
import Dialog from 'material-ui/Dialog';
import RefreshIndicator from 'material-ui/RefreshIndicator';

const BlockingLoader = ( { open }) => {

  return (
    <Dialog
      bodyStyle={{margin:0, padding:0}}
      open={open}
      style={{width: '0px', marginLeft: '50%', backgroundColor: 'transparent'}}
    >

      <RefreshIndicator
        style={{display: 'inline-block'}}
        size={50}
        left={50}
        top={30}
        loadingColor="#FF9800"
        status="loading"
      />
    </Dialog>  );
}
export default BlockingLoader;


// WEBPACK FOOTER //
// ./src/screens/layout/progressbar.js